import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import Heading from 'components/Luxkit/Typography/Heading'
import CardCarousel from 'components/Luxkit/Carousel/CardCarousel'
import DreamBlockItem from './DreamBlockItem'
import LayoutContainer from 'components/Common/LayoutContainer'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import { skip, take } from 'lib/array/arrayUtils'
import useToggle from 'hooks/useToggle'
import TextButton from 'components/Luxkit/Button/TextButton'
import SlideDown from 'components/Common/SlideDown'

const Wrapper = styled.div`
  padding: ${rem(40)} 0;
  background: ${props => props.theme.palette.neutral.default.eight};

  > * + * {
    margin-top: ${rem(40)};
  }
`

const VerticalItems = styled(CSSBreakpoint)`
  display: flex;
  flex-direction: column;
  gap: ${rem(16)};
`

export interface Props {
  tiles: Array<App.HubTile>;
  title: string;
}

function DreamBlock({ tiles, title }: Props) {
  const [showMore, toggleShowMore] = useToggle()

  return (
    <Wrapper>
      <Heading align="center" variant="heading3">{title}</Heading>
      <LayoutContainer>
        <CSSBreakpoint min="tablet">
          <CardCarousel pageSize={4} width={rem(270)}>
            {tiles.map((tile, index) => <DreamBlockItem {...tile} key={index} />)}
          </CardCarousel>
        </CSSBreakpoint>
        <VerticalItems max="mobile">
          {take(tiles, 3).map((tile, index) => <DreamBlockItem {...tile} key={index} />)}
          {tiles.length > 3 && <>
            <SlideDown show={showMore}>
              {skip(tiles, 3).map((tile, index) => <DreamBlockItem {...tile} key={index} />)}
            </SlideDown>
            <TextButton kind="secondary" onClick={toggleShowMore}>
              {showMore ? 'View less' : 'View more'}
            </TextButton>
          </>}
        </VerticalItems>
      </LayoutContainer>
    </Wrapper>
  )
}

export default DreamBlock
